import * as React from 'react'

import { ClipSource } from '../../libs/speech/clipSource'

interface ReadAloudSourceProps {
  children: React.ReactNode;
  source: ClipSource | null;
}

const ReadAloudSourceContext = React.createContext<ClipSource | null>(null)

const ReadAloudSource = ({ children, source, }: ReadAloudSourceProps) => {
  const id = source ? source.id : null
  const type = source ? source.type : null
  const value = React.useMemo(() => (id === null || type === null ? null : { id, type, }), [id, type])
  return <ReadAloudSourceContext.Provider value={value}>{children}</ReadAloudSourceContext.Provider>
}

const useReadAloudSource = () => React.useContext(ReadAloudSourceContext)

export { ReadAloudSource, useReadAloudSource }
